import { useQuery } from '@tanstack/react-query';
import api from '../../api/api';
import { useUserStore } from '../../stores/userStore';
import { badgePreview } from './generated/preview';
import { unwrapCollection } from './model';
export const badgeKey = (id, nickname) => ['badges', id ?? 'guest', nickname ?? 'mine'];
export default function useBadges(nickname, active = true) {
  const user = useUserStore((s) => s.user);
  return useQuery({
    queryKey: badgeKey(user?.id, nickname),
    enabled: active && !!(nickname || user?.id),
    retry: false,
    gcTime: 0,
    staleTime: 30000,
    queryFn: async ({ signal }) => {
      try {
        return unwrapCollection(
          await api.getAuth(
            nickname ? `/users/${encodeURIComponent(nickname)}/badges` : '/me/badges',
            { signal, suppressGlobalError: true },
          ),
        );
      } catch (e) {
        if (!nickname && e.response?.status === 404) return badgePreview;
        throw e;
      }
    },
  });
}
